import React from "react";
import doctorsImage from "../../../assets/images/doctors-image.png";
import referBgImage from "../../../assets/images/refer-bg.png";
import { useNavigate } from "react-router-dom";
import arrowRight from "../../../assets/images/arrow-right.svg";

const ReferCarePlan: React.FC = () => {
  const navigate = useNavigate();
  const navigateHandler = () => {
    navigate("/patient-logs");
  };
  return (
    <section className="flex flex-col mt-6 w-full text-lg font-medium leading-none text-center text-white rounded-none h-[450px]">
      <div className="flex flex-col w-full">
        <div className="relative flex flex-col px-4 pt-48 h-[450px]">
          <img
            loading="lazy"
            src={referBgImage}
            alt=""
            className="object-cover absolute inset-0 size-full w-full h-[350px] top-[10px] left-[0.58px]"
          />

          <img
            loading="lazy"
            src={doctorsImage}
            alt=""
            className="object-cover absolute inset-0 w-[338px] h-[233.63px] mx-auto"
          />
          <div className="absolute inset-0 w-full bg-custom-gradient z-10 rounded-b-[30px]"></div>

          <h1 className="font-poppins z-10 text-[42px] mb-2 mt-12 font-semibold leading-[32px] text-left text-[#1F2933]">
            Remote Care
          </h1>
          <p className="font-poppins z-10 text-[14px] leading-[22px] font-normal text-left text-[#3D4854]">
            Start recommending care plans to your patients. Help them access
            personalised care and track progress.{" "}
          </p>
          <div className="flex relative z-10 flex-col mb-0 w-full mt-5">
            <button
              onClick={navigateHandler}
              className="flex overflow-hidden gap-2 justify-center items-center px-4 py-4 w-full bg-indigo-600 rounded-2xl min-h-[55px]"
            >
              <span className="self-stretch my-auto">
                Check patients vitals
              </span>
              <img
                loading="lazy"
                src={arrowRight}
                alt=""
                className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
              />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferCarePlan;
